// social/luceProvami.ts — v045: nello Store, se chi guarda resta fermo qualche secondo (app.store_luce_secondi), il
// «Provalo» di un filtro a caso tra quelli sullo schermo si illumina e dice «Provami! 👀». Al primo tocco o
// scorrimento la luce si spegne e il conto riparte. Il proprietario: «interattivo, deve invogliare».
import { useEffect, type RefObject } from "react";
import { eNumero, leggiImpostazione } from "../servizi/impostazioni.ts";
import { IMP_APP } from "../costanti.ts";

export function useLuceProvami(griglia: RefObject<HTMLElement | null>, attiva: boolean): void {
  useEffect(() => {
    const secondi = leggiImpostazione(IMP_APP.storeLuceSecondi, 8, eNumero);
    if (!attiva || secondi < 0) return;
    let timer = 0;
    let acceso: HTMLElement | null = null;
    const spegni = () => {
      acceso?.removeAttribute("data-luce");
      acceso = null;
    };
    const accendi = () => {
      const ul = griglia.current;
      if (!ul || document.hidden || document.querySelector("dialog[open], .ld-guida, .ld-anteprima")) return riparti();
      const alto = window.innerHeight;
      const visibili = [...ul.querySelectorAll<HTMLElement>(".ld-carta-prova-pulsante")].filter((b) => {
        const r = b.getBoundingClientRect();
        return r.top > 70 && r.bottom < alto - 20 && r.width > 0;
      });
      if (!visibili.length) return riparti();
      acceso = visibili[Math.floor(Math.random() * visibili.length)]!;
      acceso.setAttribute("data-luce", "");
    };
    const riparti = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(accendi, secondi * 1000);
    };
    const tocco = () => {
      spegni();
      riparti();
    };
    const eventi = ["pointerdown", "scroll", "keydown", "wheel"] as const;
    eventi.forEach((e) => window.addEventListener(e, tocco, { passive: true, capture: true }));
    riparti();
    return () => {
      window.clearTimeout(timer);
      spegni();
      eventi.forEach((e) => window.removeEventListener(e, tocco, { capture: true }));
    };
  }, [griglia, attiva]);
}
